import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Footer from './Footer';
import NavMenu from './NavMenu';
import { toggleNavInverse } from '../../store/actions';
import './Layout.css';
import Scroll from '../common/Scroll';
import config from '../../constant/config';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offsetHeight: window.document.body.offsetHeight,
      innerHeight: window.innerHeight,
      scrollVisible: false,
    };
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.updateWindowDimensions();
    }
    window.addEventListener('scrollY', this.handleScroll);
  }

  handleScroll() {
    if (window.scrollY > 300) {
      this.setState({
        scrollVisible: true,
      });
    } else {
      this.setState({
        scrollVisible: false,
      });
    }
  }

  updateWindowDimensions() {
    this.setState({
      offsetHeight: window.document.body.offsetHeight,
      innerHeight: window.innerHeight,
    });
  }

  render() {
    return (
      <Fade>
        <Grid fluid>
          <Row>
            <NavMenu />
          </Row>
          <Row className="main-content">
            <div
              role="presentation"
              className={this.props.navOpaque ? 'page-wrapper-opaque' : 'page-wrapper'}
              onClick={() => {
                if (!this.props.navInverse) {
                  this.props.toggleNavInverse();
                }
              }
              }
              onKeyDown={() => {
                if (!this.props.navInverse) {
                  this.props.toggleNavInverse();
                }
              }
              }
            >
              {this.props.children}
            </div>
            {((this.state.offsetHeight / 2 > this.state.innerHeight)
              && config.scrollableRoutes.includes(this.props.location.pathname)
              && this.state.scrollVisible)
              && window.innerWidth > 1000 && <Scroll />
            }
          </Row>
          <Row>
            <Footer showGetInTouch={this.props.location.pathname !== '/contact' && this.props.location.pathname !== '/error'} />
          </Row>
        </Grid >
      </Fade>
    );
  }
}

const mapStateToProps = state => ({
  navInverse: state.navInverse,
  navOpaque: state.navOpaque,
});

const mapDispatchToProps = dispatch => ({
  toggleNavInverse: () => {
    dispatch(toggleNavInverse());
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));




// WEBPACK FOOTER //
// ./src/components/common/Layout.js